export const THEME = {
  colors: {
    avatarFallback: "rgb(var(--color-slate-200))",
    danger: "rgb(var(--color-red-500))",
  },
  chart: {
    primary: "rgb(var(--color-blue-500))",
    success: "rgb(var(--color-emerald-500))",
    danger: "rgb(var(--color-red-500))",
  },
} as const;
